import { ColorSchemeScript, MantineProvider } from '@mantine/core'
import theme from '@/theme'
import { cssVariableResolver } from '@/theme/cssVariableResolver'
import { ColorSchemes } from '@/enums/colorSchemes'

import '@mantine/core/styles.layer.css'
import '@mantine/dates/styles.layer.css'
import '@mantine/dropzone/styles.layer.css'
import '@mantine/notifications/styles.layer.css'
import 'mantine-datatable/styles.layer.css'
import '@/styles/index.css'

function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ColorSchemeScript defaultColorScheme={ColorSchemes.LIGHT} />
      <MantineProvider
        theme={theme}
        defaultColorScheme={ColorSchemes.LIGHT}
        cssVariablesResolver={cssVariableResolver}
        withCssVariables
      >
        {children}
      </MantineProvider>
    </>
  )
}

export default ThemeProvider
